import PropTypes from 'prop-types';
import React from 'react';
import Button from '@99designs/react-components/components/Button';
import { PopoverCard } from '@99designs/react-components/components/PopoverCard';
import { FormattedMessage } from 'react-intl';
import onboardingPrompt from 'contest/components/onboarding-prompts/onboardingPrompt';
import contestStageSelector from 'contest/components/onboarding-prompts/contestStageSelector';

const PollsTabOnboardingPromptComponent = ({ dismiss, children }) => {
    return (
        <PopoverCard
            layerSelector="#content-overlay-layer"
            variations={['onboarding-prompt']}
            card={
                <div>
                    <h5 className="heading heading--h5 heading--pacific">
                        <FormattedMessage id="onboarding_prompt_polls_tab_heading" />
                    </h5>
                    <p>
                        <FormattedMessage id="onboarding_prompt_polls_tab_paragraph" />
                    </p>
                    <Button variations={['info', 'small']} onClick={dismiss}>
                        <FormattedMessage id="onboarding_prompt_polls_tab_button" />
                    </Button>
                </div>
            }
        >
            <span onClick={dismiss}>{children}</span>
        </PopoverCard>
    );
};
PollsTabOnboardingPromptComponent.propTypes = {
    dismiss: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default contestStageSelector(
    ['selecting-finalists', 'final-round', 'selecting-winner'],
    onboardingPrompt('polls-tab', 200, PollsTabOnboardingPromptComponent)
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/PollsTabPrompt.js